import React from 'react';
import { AdminLayout } from '../../components/layout/AdminLayout';
import { useTenant } from '../../lib/tenant-context';
import { useLoyaltyDashboard } from '../../lib/loyalty-hooks';
import { Card } from '../../components/ui/Card';
import { Users, Star, Gift, Trophy } from 'lucide-react';
import { formatCurrency } from '../../lib/utils';
export function LoyaltyDashboardPage() {
  const {
    restaurant,
    role,
    signOut
  } = useTenant();
  const {
    customers,
    loading
  } = useLoyaltyDashboard(restaurant.restaurant_id);
  const totalCustomers = customers.length;
  const totalPoints = customers.reduce((sum, c) => sum + (c.current_points || 0), 0);
  const totalRewardsAvailable = customers.reduce((sum, c) => sum + (c.available_rewards_count || 0), 0);
  const totalRewardsRedeemed = customers.reduce((sum, c) => sum + (c.redeemed_rewards_count || 0), 0);
  return <AdminLayout restaurant={restaurant} role={role} onSignOut={signOut} data-id="element-3118">
      <div className="p-6 max-w-7xl mx-auto space-y-6" data-id="element-3119">
        <div data-id="element-3120">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-3121">
            Programa de Lealtad
          </h1>
          <p className="text-gray-500" data-id="element-3122">
            Gestiona tus clientes frecuentes y beneficios
          </p>
        </div>

        {/* KPIs */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-3123">
          <Card className="p-6" data-id="element-3124">
            <div className="flex items-center gap-4" data-id="element-3125">
              <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3126">
                <Users className="w-6 h-6 text-blue-600" data-id="element-3127" />
              </div>
              <div data-id="element-3128">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3129">
                  Clientes Leales
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3130">
                  {totalCustomers}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3131">
            <div className="flex items-center gap-4" data-id="element-3132">
              <div className="w-12 h-12 bg-yellow-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3133">
                <Star className="w-6 h-6 text-yellow-600" data-id="element-3134" />
              </div>
              <div data-id="element-3135">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3136">
                  Puntos Emitidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3137">
                  {totalPoints}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3138">
            <div className="flex items-center gap-4" data-id="element-3139">
              <div className="w-12 h-12 bg-green-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3140">
                <Gift className="w-6 h-6 text-green-600" data-id="element-3141" />
              </div>
              <div data-id="element-3142">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3143">
                  Beneficios Disponibles
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3144">
                  {totalRewardsAvailable}
                </p>
              </div>
            </div>
          </Card>
          <Card className="p-6" data-id="element-3145">
            <div className="flex items-center gap-4" data-id="element-3146">
              <div className="w-12 h-12 bg-purple-50 rounded-xl flex items-center justify-center shrink-0" data-id="element-3147">
                <Trophy className="w-6 h-6 text-purple-600" data-id="element-3148" />
              </div>
              <div data-id="element-3149">
                <p className="text-sm text-gray-500 font-medium" data-id="element-3150">
                  Beneficios Redimidos
                </p>
                <p className="text-2xl font-bold text-gray-900" data-id="element-3151">
                  {totalRewardsRedeemed}
                </p>
              </div>
            </div>
          </Card>
        </div>

        {/* Customer Table */}
        <Card className="overflow-hidden" data-id="element-3152">
          <div className="p-6 border-b border-gray-200" data-id="element-3153">
            <h2 className="font-bold text-gray-900" data-id="element-3154">Directorio de Clientes</h2>
          </div>
          <div className="overflow-x-auto" data-id="element-3155">
            <table className="w-full text-left text-sm" data-id="element-3156">
              <thead className="bg-gray-50 text-gray-500" data-id="element-3157">
                <tr data-id="element-3158">
                  <th className="px-6 py-4 font-medium" data-id="element-3159">Cliente</th>
                  <th className="px-6 py-4 font-medium" data-id="element-3160">Teléfono</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3161">Visitas</th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3162">
                    Total Gastado
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3163">
                    Ticket Promedio
                  </th>
                  <th className="px-6 py-4 font-medium text-right" data-id="element-3164">Puntos</th>
                  <th className="px-6 py-4 font-medium" data-id="element-3165">Nivel</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200" data-id="element-3166">
                {loading ? <tr data-id="element-3167">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-3168">
                      Cargando clientes...
                    </td>
                  </tr> : customers.length === 0 ? <tr data-id="element-3169">
                    <td colSpan={7} className="px-6 py-8 text-center text-gray-500" data-id="element-3170">
                      No hay clientes registrados aún.
                    </td>
                  </tr> : customers.map(customer => <tr key={customer.customer_id} className="hover:bg-gray-50" data-id="element-3171">
                      <td className="px-6 py-4 font-medium text-gray-900" data-id="element-3172">
                        {customer.name || 'Sin nombre'}
                      </td>
                      <td className="px-6 py-4 text-gray-500" data-id="element-3173">
                        {customer.phone}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-3174">
                        {customer.total_orders}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-900" data-id="element-3175">
                        {formatCurrency(customer.total_spent, restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right text-gray-500" data-id="element-3176">
                        {formatCurrency(customer.total_spent / Math.max(1, customer.total_orders), restaurant.currency_symbol)}
                      </td>
                      <td className="px-6 py-4 text-right font-bold text-brand-charcoal" data-id="element-3177">
                        {customer.current_points}
                      </td>
                      <td className="px-6 py-4" data-id="element-3178">
                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-800" data-id="element-3179">
                          {customer.current_level || 'Inicial'}
                        </span>
                      </td>
                    </tr>)}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </AdminLayout>;
}